import { ACTIONS_COMMISSION } from '../actions/commission';

export const commission = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_COMMISSION.INIT_COMMISSION: {
      return { ...action.data };
    }

    default:
      return state;
  }
};
